import { createContext, useEffect, useState } from "react";
import axios from "../../axios/axios";
import PageLoader from "../../components/PageLoader";
import InterestRateTab from "./InterestRateTab";
import { useDispatch } from "react-redux";
import { fetchBonus } from "../../redux/slice/bonusSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoaderComp from "../../components/LoaderComp";
import { Tabs } from "antd";
import { useQuery } from "react-query";

export const InterestRateContext = createContext(null);
const items = [
  {
    key: 0,
    label: `Low Tier`,
  },
  {
    key: 1,
    label: `High Tier`,
  }
];
const SingleLoanProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pagePermissions = location.state
  const { id } = useParams();
  const [interestKey, setinterestKey] = useState(0);
  const [intTabPos, setIntTabPos] = useState(0);
  const { data: productData, isLoading, isFetching, isFetched, refetch } = useQuery('product-info', async () => {
    const accessToken = localStorage.getItem('agentModuleToken');
    const resp = await axios.get(`/loan/product/info/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    //console.log("loan bouns info===============",resp?.data?.data)
    return resp?.data?.data;
  }, {
    refetchOnWindowFocus: false
  })
  useEffect(() => {
    dispatch(fetchBonus());
  }, [])
  console.log("productData============", productData)
  return (
    <>
      {(isLoading || isFetching)
        ? <PageLoader /> :
        <div className="flex_adjust">
          <div className="top_head_sec flex items-center m-[25px] max-[500px]:m-[25px_10px]">
            <div className="mr-[20px] cursor-pointer" onClick={() => navigate(-1)}>
              <img src="/images/left-circle.svg" alt="arrow" />
            </div>
            <h1 className="text-[#27272B] font-[700] text-[20px]">Loan Product Interest Rates</h1>
          </div>
          <div>
            <div className="px-[60px] max-[1300px]:px-[25px] max-[500px]:px-[0px]">
              <div className="flex items-center max-[500px]:px-[20px]">
                <span><img src={`https://api.ohhto.com/${productData.icon}`} alt="bank logo" className="w-[40px] h-[40px] object-cover rounded-[4px] bg-white" /></span>
                <h2 className="text-[#0D062D] font-[700] text-[16px] ml-[13px]">{productData?.name}</h2>
                {
                  productData.hasPremium || productData.featured ?
                    <span className="inline-block ml-[12px]">
                      {
                        productData.hasPremium ?
                          <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500] mr-[10px]"><img src="/images/prem_icon.svg" className="w-[16px]" alt="star" /> <span className="relative top-[1px]">Premium</span></span>
                          : null
                      }
                      {
                        productData.featured ?
                          <span className="inline-flex text-[13px] items-center border border-[#E1E1E1] gap-[0_6px] rounded-[4px] p-[4px_10px] text-[#263238] font-[500]"><img src="/images/star.svg" className="w-[16px]" alt="star" /> <span className="relative top-[1px]">Featured</span></span>
                          : null
                      }
                    </span> : null
                }
              </div>
              <div className="flex flex-wrap items-center gap-[10px_35px] mt-[15px] max-[500px]:px-[20px]">
                <p className="text-[12px] flex items-center">
                  <img src="/images/fi_clock.svg" alt="calendar" className="mr-[5px]" />
                  Approval time: <strong className="ml-[5px] font-[600]">{productData?.approvaltimeinfo['name']}</strong>
                </p>
                <p className="text-[12px] flex items-center">
                  <img src="/images/fi_zap.svg" alt="calendar" className="mr-[5px]" />
                  Loan to Value: <strong className="ml-[5px] font-[600]">{productData?.ltvinfo['name']}</strong>
                </p>
              </div>
              <div className="mt-[15px] flex items-center flex-wrap gap-[10px] max-[500px]:px-[20px]">
                <span className="inline-block text-[#333333] text-[12px] p-[6px_10px] rounded-[4px] border border-[#9BACB9]">{productData?.vehicleinfo['name']}</span>
                <span className="inline-block text-[#333333] text-[12px] p-[6px_10px] rounded-[4px] border border-[#9BACB9]">{productData?.categoryinfo['name']}</span>
                <span className="inline-block text-[#333333] text-[12px] p-[6px_10px] rounded-[4px] border border-[#9BACB9]">{productData?.typeinfo['name']}</span>
                <span className="inline-block text-[#333333] text-[12px] p-[6px_10px] rounded-[4px] border border-[#9BACB9]">{productData?.schemeinfo['name']}</span>
                <span className="inline-block text-[#333333] text-[12px] p-[6px_10px] rounded-[4px] border border-[#9BACB9]">{productData?.motor_typeinfo['name']}</span>
                <span className="inline-block text-[#333333] text-[12px] p-[6px_10px] rounded-[4px] border border-[#9BACB9]">{productData?.usageinfo['name']}</span>
              </div>
            </div>
            <Tabs items={items.map((item) => {
              if (productData.interests.length < 2 && item.key === 1) {
                return {
                  ...item,
                  disabled: true
                }
              } else {
                return item
              }
            })} className="interest_tab_sec" defaultActiveKey={interestKey} onChange={(key) => { setinterestKey(key); setIntTabPos(0) }} />
            <InterestRateContext.Provider value={{ intTabPos, setIntTabPos, refetch, isFetching, productData, pagePermissions }}>
              <div className="px-[60px] max-[1300px]:px-[25px] max-[500px]:px-[0px]">
                {
                  productData ?
                    productData.interests.map((item, idx) => {
                      if (idx === interestKey) {
                        return (
                          <InterestRateTab key={idx} itemIdx={idx} numInterest={idx + 1} productData={item} />
                        )
                      }
                      return null;
                    }) : <LoaderComp />
                }
              </div>
            </InterestRateContext.Provider>
          </div>
        </div>
      }
    </>
  )
};

export default SingleLoanProduct;
